<script lang="ts">
  import { get, Readable, derived, writable } from "svelte/store";
  import Window from "../components/Window.svelte";
  import { FileMgr } from "../stores/FileMgr";
  import type { Rect, WinProps } from "../scripts/WinTypes";

  import Path from "../scripts/Path";
  import { onMount, SvelteComponent } from "svelte";
  import { addLog } from "../stores/LoggerStore";
  import { Node, Dir, File, filesInDirectory } from "../scripts/FileTypes";
  import ProcMgr from "../stores/ProcMgr";
  import BakeryIcon from "../components/BakeryIcon.svelte";
  import { prevent_default } from "svelte/internal";
  export let winProps: WinProps;

  const _setInitialWinProp = () => {
    winProps.name = winProps.name || "Bakery";
    if (!winProps.data) {
      winProps.data = {};
    }
    winProps.data.rect =
      winProps.data.rect ||
      <Rect>{
        top: "10%",
        left: "15%",
        width: "70%",
        height: "80%",
      };
  };
  _setInitialWinProp();

  const filemgr = FileMgr.getInstance();
  const procmgr = ProcMgr.getInstance();

  const makeFile = (filename, type, iconPath?, data?) => {
    let node = new Node(new Path("~/" + filename), type);
    if (iconPath) {
      node.setIconPath(iconPath);
    }
    return <File>{
      node: node,
      data: data,
    };
  };
  interface FileView {
    id: number;
    file: File;
    show: boolean;
  }
  let _id = 1;

  const files = writable([
    // makeFile("JamHub", "hub"),
    { id: _id++, file: makeFile("Terminal", "terminal"), show: true },
    { id: _id++, file: makeFile("Save Bread", "savebread"), show: true },
    { id: _id++, file: makeFile("Load Bread", "loadbread"), show: true },
    { id: _id++, file: makeFile("Notepad", "notepad"), show: true },
    { id: _id++, file: makeFile("Broom", "broom"), show: true },
    { id: _id++, file: makeFile("Postman", "postman"), show: true },
    { id: _id++, file: makeFile("Atelier", "atelier"), show: true },
    { id: _id++, file: makeFile("Logger", "logger"), show: true },
    { id: _id++, file: makeFile("About", "about"), show: true },
    { id: _id++, file: makeFile("Settings", "settings"), show: true },
    { id: _id++, file: makeFile("Styler", "styler"), show: true },
    {
      id: _id++,
      file: {
        node: makeFile("Finder", "finder").node.setCmd("finder ~/"),
        data: {},
      },
      show: true,
    },
  ]);
  $: foundAny = derived(files, (_) =>
    _.reduce((prev, file) => {
      if (prev || file.show) {
        return true;
      }
      return false;
    }, false)
  );

  const dictionary = () => {
    const retval = [];
    get(files).forEach((file) => {
      retval.push([file.file.node.type, file.id]);
      retval.push([file.file.node.path.last, file.id]);
    });
    return retval;
  };

  let containerElem: HTMLElement;
  onMount(() => {
    if (containerElem) {
      console.log("Container elem");
      containerElem.style.setProperty("min-height", "100%");
    }
    inputElem?.focus();
  });

  let inputElem: HTMLElement,
    inputValue = "";
  const handleInput = (e) => {
    if (inputValue === "") {
      files.update((files) =>
        files.map((file) => {
          file.show = true;
          return file;
        })
      );
      return;
    }
    const dic = dictionary();
    const found = dic.reduce((prev, cur) => {
      if ((cur[0] as string).includes(inputValue)) {
        prev.push(cur[1]);
      }
      return prev;
    }, []);
    files.update((_files) => {
      return _files.map((file) => {
        if (found.includes(file.id)) {
          file.show = true;
        } else {
          file.show = false;
        }
        return file;
      });
    });
  };
</script>

<Window {winProps}>
  <div class="container" bind:this={containerElem}>
    <h1 class="title">JamOS Bakery</h1>
    <textarea
      spellcheck="false"
      rows="1"
      class="input-box ver-center"
      bind:this={inputElem}
      bind:value={inputValue}
      on:input={handleInput}
      on:keydown={(e) => {
        if (e.key === "Escape") {
          inputValue = "";
          handleInput(e);
        }
      }}
      placeholder="Search Apps"
    />
    <p class="desc">Add/Remove apps on your desktop💻</p>
    {#if $foundAny}
      <p class="desc">Feel free to click on apps!</p>
      <div class="icon-container">
        {#each $files as file (file.id)}
          {#if file.show}
            <BakeryIcon file={file.file} />
          {/if}
        {/each}
      </div>
    {:else}
      <div class="not-found">No app found🥲 : {inputValue}</div>
    {/if}
  </div>
</Window>

<style>
  .title {
    margin-bottom: 40px;
    font-size: 2rem;
    text-align: center;
  }

  .desc {
    font-size: 1.5rem;
    margin-bottom: 60px;
    text-align: center;
  }

  .container {
    /* position: relative; */
    width: 100%;
    box-sizing: border-box;
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
  }
  p {
    margin-bottom: 100px;
  }
  .icon-container {
    margin: 0;
    box-sizing: border-box;
    display: grid;
    /* height: 100%; */
    /* height: calc(100% - 40px); */
    width: 100%;
    padding: 5px;
    gap: 100px;
    grid-auto-flow: row;
    grid-template-columns: repeat(auto-fill, 120px);
    grid-template-rows: repeat(auto-fill, 140px); /* Your number of rows */
    /* direction: rtl; */
    justify-content: center;
  }
  .input-box {
    margin: 10px auto;
    width: 30%;
    white-space: nowrap;
    overflow: hidden;
    resize: none;
    border-radius: 20px;
    padding: 10px;
    box-sizing: border-box;
    outline: none;
  }
  .not-found {
    width: 100%;
    font-size: 1.5rem;
    text-align: center;
  }
</style>
